module.exports = __webpack_public_path__ + "img/start.2242f678.png";